import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=1c6395d2&scoped=true&lang=pug&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.scss?vue&type=style&index=0&id=1c6395d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6395d2",
  null
  
)

export default component.exports